








































import { Prop } from 'vue-property-decorator';
import Component, { mixins } from 'vue-class-component';
import Formatter from '@/mixins/formatter';

import { Phone } from '@/data/hikari/phone';

import RadioButton from '@/components/Atoms/Input/RadioButton.vue';
import UnorderedList from '@/components/Atoms/List/UnorderedList.vue';
import ListItem from '@/components/Atoms/ListItem/ListItem.vue';
import PhoneOptionAttention from '@/components/Pages/HikariEstimate/PhoneOptionAttention.vue';
import DL from '@/components/Atoms/List/DefinedList.vue';
import DT from '@/components/Atoms/ListItem/DefinitionTerm.vue';
import DD from '@/components/Atoms/ListItem/DefinitionDescription.vue';
import Price from '@/components/Atoms/Text/Price.vue';
import PhoneOption from '@/components/Pages/HikariEstimate/PhoneOption.vue';

@Component({
  components: {
    RadioButton,
    UnorderedList,
    ListItem,
    PhoneOptionAttention,
    DL,
    DT,
    DD,
    PhoneOption,
    Price,
  },
})
export default class PhoneContents extends mixins(Formatter) {
  @Prop() phoneList!: Phone[];

  public list = this.phoneList.concat([
    new Phone('none', '', '申し込まない', {}, 0, []),
  ]);

  get phonePlan(): string {
    return this.$store.getters['hikari/phonePlan'];
  }

  isBorder(index: number, options: object): boolean {
    return (
      index === 1 || index === 0 || index === Object.keys(options).length - 1
    );
  }
}
